import React from 'react';
import Dropdown from './Dropdown.jsx'

export default class SortDropdown extends React.Component {
	constructor(props) {
		super(props);
	}

	render(props) {
		const {
			parentFunction,
			options,
			selectedOption = "default",
			selectedLabel,
			disabled = false
		} = this.props

		const onClickItem = (e) => {
			parentFunction(e.value);
		}

		return (
			<Dropdown
				parentFunction={onClickItem}
				icon="fa-regular fa-bars-sort"
				title={'sorting_button'.trad() + ' ' +

					(selectedOption == 'default' ?
						''
						:
						' ' + (selectedLabel || selectedOption?.trad()))
				}
				items={options}
				selectedItem={selectedOption}
				disabled={disabled}
			/>
		);
	}
}